var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.linkcard)?_c('a',{staticClass:"link-card",attrs:{"href":("/" + (_vm.linkcard.url))}},[_c('div',{staticClass:"link-card-inner",style:({
      background: _vm.linkcard.image.data
        ? ("url(" + (this.Url(_vm.linkcard.image.data.attributes.url)) + ")")
        : '#fff'
    })},[_c('h3',[_vm._v(_vm._s(_vm.linkcard.title))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }